/**
 *  @class
 *  @function HotspotLayer
 *
 *  The layer that places product hotspots on an image as it is drawn
 *  (snippets/hotspot-layer.liquid). A cropped (cover) image can push a pin
 *  out of the frame at some sizes, and the layer clips it there. Such a pin
 *  is made inert, so it takes no focus (a keyboard user would land on a pin
 *  and a bubble that don't show) and screen readers skip it. A pin counts
 *  as out once its centre is, since less than half of its dot shows then.
 *
 *  The pins are placed with container query units, so they move against
 *  the frame only when the frame changes size: they are checked again on
 *  every resize of the layer (which covers the mobile breakpoint too).
 *  The section script tags can repeat on a page, so this defines the
 *  element once.
 */
if (!customElements.get('hotspot-layer')) {
  class HotspotLayer extends HTMLElement {
    connectedCallback() {
      if (this.observer || typeof ResizeObserver === 'undefined') {
        return;
      }
      this.observer = new ResizeObserver(() => this.update());
      this.observer.observe(this);
    }
    disconnectedCallback() {
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }
    }
    update() {
      const frame = this.getBoundingClientRect();
      if (!frame.width || !frame.height) {
        return;
      }
      this.querySelectorAll('.product-hotspot').forEach((hotspot) => {
        const pin = hotspot.getBoundingClientRect(),
          x = pin.left + pin.width / 2,
          y = pin.top + pin.height / 2,
          // Half a pixel of rounding either way: a pin on the edge itself
          // (at 0 or 100 on an image that isn't cropped) stays.
          out = x < frame.left - 0.5 || x > frame.right + 0.5 || y < frame.top - 0.5 || y > frame.bottom + 0.5;
        if (hotspot.hasAttribute('inert') !== out) {
          hotspot.toggleAttribute('inert', out);
        }
      });
    }
  }
  customElements.define('hotspot-layer', HotspotLayer);
}
